import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import {
  IExistencesInWarehouse,
  IExistenceUpdateWarehouse,
} from 'safe'
import {
  CLEAN_ITEMS,
  ExistencesTypes,
  SET_EXISTENCE,
  UPDATE_WAREHOUSE_EXISTENCE,
  WarehousesTypes,
} from './actionTypes'
const server = process.env.REACT_APP_SERVER_URL

const setExistences = (items: IExistencesInWarehouse): ExistencesTypes => ({
  type: SET_EXISTENCE,
  payload: items,
})

const updateExistenceWarehouse = (
  warehouse: IExistenceUpdateWarehouse
): WarehousesTypes => ({
  type: UPDATE_WAREHOUSE_EXISTENCE,
  payload: warehouse,
})

const cleanItemsWarehouse = (): ExistencesTypes => ({ type: CLEAN_ITEMS })

// export const fetchExistences = (
//     id: string
//   ): ThunkAction<Promise<void>, {}, {}, ExistencesTypes> => async (
//     dispatch: ThunkDispatch<{}, {}, ExistencesTypes>
//   ): Promise<void> => {
//     try {
//         const response: AxiosResponse<{
//             status: number
//           }> = await axios.get(
//             `${server}/inventory/existence?id=${id}}`
//           )
//         dispatch(setExistence())
//     } catch (e) {
//       throw e
//     }
//   }

export const fetchExistences =
  (
    warehouseId: string | undefined,
    querySearch: string[] = [],
    paginationParams: string[],
    evaluate = 'none'
  ): ThunkAction<Promise<void>, {}, {}, ExistencesTypes | WarehousesTypes> =>
  async (
    dispatch: ThunkDispatch<{}, {}, ExistencesTypes | WarehousesTypes>
  ): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        id: string
        name: string
        items: {
          barcode: string
          brand: string
          description: string
          id: string
          name: string
          quantity: string
          sku: string
        }[]
        numberOfPages: number
      }> = await axios.get(
        `${server}/inventory/existence?id=${warehouseId}&${[
          ...querySearch,
          ...paginationParams,
        ].join('&')}`
      )
      dispatch(
        setExistences({
          warehouse: { id: warehouseId },
          // existences: response.data.existencesOfWarehouse.map(
          //   (existence, i) => ({
          //     item: existence.item,
          //     quantity: existence.quantity,
          //     date: existence.date,
          //     category: existence.item.category.name,
          //     location: existence.location, //mosca
          //     id: existence.id,
          //   })
          // ),
          existences: response?.data?.items || [],
          numberOfPages: response?.data?.numberOfPages,
        })
      )
      // dispatch(updateExistenceWarehouse({idWarehouse: warehouseId, numberOfExistences: response.data.existencesOfWarehouse[0]?.location.numberOfExistences || "0"}))
      // dispatch(
      //   updateExistence(
      //     warehouseId,
      //     response.data.existencesOfWarehouse[0]?.location.numberOfExistences ||
      //       '0'
      //   )
      // )
    } catch (e) {
      throw e
    }
  }

export const updateExistence = (idWarehouse, numberOfExistences) => {
  return updateExistenceWarehouse({ idWarehouse, numberOfExistences })
}

export const cleanItems = (): { type: string } => {
  return cleanItemsWarehouse()
}
